export default theme => ({
  root: {},
  modalFinish: {
    textAlign: 'center'
  },
  finishHeader: {
    justifyContent: 'center'
  },
  finishFooter: {
    justifyContent: 'center !important'
  }
});